<template>
	<div>
		<div v-if="oneData.length">
			<div class="title">网站一级页面</div>
			<div class="layout">
				<link-select
					:value="value"
					v-for="item in oneData"
					:key="item.id"
					v-bind="item"
					@check="check"
				></link-select>
				<div class="plus" @click="add"><i class="el-icon-plus iconSpace"></i>自定义添加</div>
			</div>
		</div>
		<div v-if="choose.length">
			<div class="title">已选</div>
			<div class="chooseBox">
				<div v-for="item in choose" :key="item.id" class="chooseBorder">
					<div class="contentTitle">{{ item.content }}</div>
					<linkCustom
						:customObj="item"
						:choose="choose"
						class="linkCustom"
						ref="linkCustom1"
					></linkCustom>
				</div>
			</div>
		</div>

		<el-dialog
			title="自定义"
			:visible.sync="dialogVisible"
			width="30%"
			:before-close="
				() => {
					dialogVisible = false;
				}
			"
			:close-on-click-modal="false"
		>
			<linkCustom
				:customObj="customObj"
				:choose="choose"
				:isCustom="false"
				ref="linkCustom"
			></linkCustom>
			<span slot="footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import adsNewOnline from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
import linkSelect from '@/components/adsOnlineAuto/com/linkSelect';
import linkCustom from './linkCustom';
export default {
	props: ['value', 'name'],
	data() {
		return {
			allData: [],
			oneData: [],
			choose: [],
			customObj: {},
			dialogVisible: false,
			customData: [],
		};
	},
	components: { linkSelect, linkCustom },
	computed: {
		queryParam() {
			return this.$route.query;
		},
	},
	watch: {
		value: {
			handler(val) {
				this.choose = val;
				this.customData = val.filter(ele => {
					return ele.content == '自定义';
				});
				this.customData.forEach(e => {
					e.id = e.pageId;
					e.fileName = e.pagePath;
					e.isCustom = '自定义';
					e.content = '自定义';
					e.showText = e.showText ? e.showText : e.content;
				});
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		async getList() {
			let res = await adsNewOnline.pageList({ siteid: this.queryParam.projectId });
			if (res.data && res.data.length) {
				this.allData = res.data;
				let type = [0, 4, 5, 6, 7, 13, 23];
				this.oneData = this.allData.filter(e => {
					return e.pid === '0' && e.hideFlag == 0 && type.includes(e.type);
				});
				this.oneData = this.oneData.concat(this.customData);
			}
		},
		check(obj) {
			let flag = this.choose.some(item => {
				return obj.pageId == item.pageId;
			});
			if (flag) {
				this.choose = this.choose.filter(function (ele) {
					return ele.pageId != obj.pageId;
				});
			} else {
				this.choose.unshift(obj);
			}
			this.$emit('input', this.choose);
		},
		add() {
			this.customObj = {
				content: '自定义',
				domain: this.queryParam.name,
				showText: '',
				pagePath: '',
				explain1: '',
				explain2: '',
				pageId: '',
			};
			this.dialogVisible = true;
		},
		confirm() {
			this.$refs.linkCustom.$refs.customForm.validate(valid => {
				if (valid) {
					this.choose.unshift({
						...this.customObj,
						id: new Date().getTime(),
						pageId: new Date().getTime(),
					});
					this.oneData.push({
						name: this.customObj.showText,
						fileName: this.customObj.pagePath,
						isCustom: true,
						id: new Date().getTime(),
					});
					this.$emit('input', this.choose);
					this.dialogVisible = false;
				} else {
					return false;
				}
			});
		},
	},
	mounted() {
		this.getList();
	},
};
</script>

<style lang="scss" scoped>
.layout {
	margin-bottom: 30px;
	display: grid;
	grid-template-columns: repeat(4, 24%);
	gap: 20px;
}
.title {
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #333333;
	margin-bottom: 15px;
	margin-left: 10px;
}
.iconSpace {
	margin-right: 10px;
}
.plus {
	display: flex;
	height: 40px;
	box-shadow: 0px 2px 8px 0px rgba(51, 51, 51, 0.15);
	border-radius: 4px;
	padding: 12px 20px;
	cursor: pointer;
	font-weight: 400;
	color: #3da1ff;
	align-items: baseline;
	justify-content: center;
}
.contentTitle {
	height: 44px;
	background: #eeeeee;
	border-radius: 4px;
	line-height: 44px;
	padding-left: 10px;
}
.chooseBox {
	display: grid;
	grid-template-columns: repeat(2, 49.5%);
	gap: 20px;
}
.chooseBorder {
	border-radius: 4px;
	border: 1px solid #e3e3e3;
	padding: 15px;
}
</style>
